import { Modal, Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { AIVerificationResult } from "../../../api";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import TaskAltIcon from '@mui/icons-material/TaskAlt';


const OverriddenModal = ({ open, handleClose, verificationResult, user_map }: { open: boolean, handleClose: () => void, verificationResult: AIVerificationResult, user_map: { [key: string]: string } }) => {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        minWidth: 100,
        p: 4,
    };
    const theme = useTheme()
    
    const formattedOverridenData = verificationResult.overridden_at ? new Date(String(verificationResult.overridden_at)).toLocaleString('en-GB', { day: 'numeric', month: 'long', year: 'numeric', minute: 'numeric', hour: 'numeric' }) : ""

    return <Modal
        open={open}
        onClose={() => {
            handleClose()
        }}
    >
        <Box sx={style} display="flex" flexDirection={"column"} gap={2}>
            <Typography variant="h6">Override Details</Typography>
            <Box>
                <Typography fontWeight={"bold"}>{verificationResult.validation_name}</Typography>
                <Typography>{verificationResult.validation_desc}</Typography>
            </Box>
            <Box display="flex" flexDirection={"column"} gap={2}>
                <Box>
                    <Typography fontWeight={"bold"}>Overriden By</Typography>
                    <Typography> {user_map[String(verificationResult.overridden_by)]}</Typography>
                </Box>

                <Box>
                    <Typography fontWeight={"bold"}>Overriden At</Typography>
                    <Typography> {formattedOverridenData}</Typography>
                </Box>

                <Box>
                    <Typography fontWeight={"bold"}>Reason Given</Typography>
                    <Typography> {String(verificationResult.overridden_reason)}</Typography>
                </Box>

                <Box>
                    <Typography fontWeight={"bold"}>New Outcome</Typography>
                    <Typography>
                        {verificationResult.outcome ? <Typography color={theme.palette.success.main}> <TaskAltIcon fontSize="inherit" /> Compliant </Typography> : verificationResult.severity == "error" ? <Typography color={theme.palette.error.main}><ErrorOutlineIcon fontSize="inherit" /> Needs Attention</Typography> : <Typography color={theme.palette.warning.main}><ErrorOutlineIcon fontSize="inherit" /> Warning</Typography> }
                    </Typography>
                </Box>
                
                
            </Box>
        </Box>
    </Modal>
}
export default OverriddenModal